import * as React from 'react';
import { AnalyticsContext } from '@atlaskit/analytics-next';
import type { SearchProps } from '@atlassian/help-center-common-component/result-base';
import { KbSnippet } from '@atlassian/help-center-common-component/result-kb-snippets';
import type { PortalInfo } from 'rest/search/kbs/types';
interface Props extends SearchProps {
    title: string;
    id: string;
    articleSnippet: string;
    isSmartSnippet: boolean;
    pageVersion: number;
    score: number;

    openNewTab?: boolean;
    isSuggestion?: boolean;
    elevated?: boolean;
    portalId?: string;
    portalName?: string;
    linkedPortals?: PortalInfo[];
}

export const parseBodyText = (text: string) =>
    // eslint-disable-next-line no-useless-escape
    text.replace(/\@\@\@hl\@\@\@/g, '<strong>').replace(/\@\@\@endhl\@\@\@/g, '</strong>');

const SearchResultKb: React.FC<Props> = ({
    title,
    portalName,
    portalId,
    id,
    articleSnippet,
    isSmartSnippet,
    pageVersion,
    score,
    linkedPortals,
    openNewTab,
    ...props
}) => {
    const articleId = id;
    const snippet = articleSnippet ? parseBodyText(articleSnippet) : '';

    const getArticleUrl = () => {
        if (portalId) {
            return `/portal/${portalId}/article/${articleId}`;
        }

        // If portalId doesnt exist in store, ie for global search, use the portalId for first linked portal
        if (Array.isArray(linkedPortals) && linkedPortals.length > 0) {
            return `/portal/${linkedPortals[0].portalId}/article/${articleId}`;
        }
        return `/article/${articleId}`;
    };

    const articleUrl = getArticleUrl();

    return (
        <AnalyticsContext
            data={{
                attributes: {
                    pageVersion,
                    score,
                    isSmartSnippet,
                    articleId,
                    portalId,
                    snippetsLength: snippet.length,
                },
            }}
        >
            <KbSnippet
                actionSubjectId="smartSuggestion"
                titleHtml={parseBodyText(title)}
                to={articleUrl}
                openNewTab={openNewTab}
                snippet={snippet}
                portalName={portalName}
                {...props}
            />
        </AnalyticsContext>
    );
};

export default SearchResultKb;
